// Polyfill for web - not needed in browser environment
import React from 'react';
import { useEffect } from 'react';
// Import DripsyProvider directly from provider module with .js extension
import {DripsyProvider} from '@dripsy/core/build/provider/index.js';
import AuthProvider from './Utils/AuthProvider';
import AppNavigation from './Screens/AppNavigation';
import Theme from './Utils/AppTheme';
import UpdateProvider from './Utils/UpdateProvider';

function App() {
  useEffect(() => {
    // Skip Facebook SDK initialization for web
    // Settings.initializeSDK();    
  }, []);
  return (
    <DripsyProvider theme={Theme}>
      <UpdateProvider autoCheck={false}>
        <AuthProvider>
          <AppNavigation />
        </AuthProvider>
      </UpdateProvider>
    </DripsyProvider>
  );
}

export default App;
